module.exports = __webpack_public_path__ + "static/04-icon-e08e0a69d0c3aaefecfac8f7d04f0c4a.png";